import { z } from "zod";
import { getAuthHeader } from "@src/utils/superagent";
import request from "superagent";
import {
  WorkerLeftEarlyResponse,
  workerLeftEarlyResponseSchema,
} from "@src/containers/facilityDashboard/ShiftCalendar/api/useGetWorkerLeftEarly";
import { API_TYPES } from "@src/appV2/api/constants";

const requestAttributes = z.object({
  shiftId: z.string(),
  replacementRequested: z.boolean(),
  leftWithPermission: z.boolean(),
  comment: z.string(),
});

export type WorkerLeftEarlyRequestAttributes = z.infer<typeof requestAttributes>;

export const workerLeftEarlyRequestSchema = z.object({
  data: z.object({
    attributes: requestAttributes,
    type: z.literal(API_TYPES.workerLeftEarlyRequest),
    id: z.string(),
  }),
});

export const workerLeftEarlyErrorSchema = z.object({
  errors: z.array(
    z.object({
      title: z.string().optional(),
      detail: z.string().optional(),
    })
  ),
});

export type WorkerLeftEarlyError = z.infer<typeof workerLeftEarlyErrorSchema>;

export interface MarkShiftWorkerLeftEarlyParams {
  shiftId: string;
  replacementRequested: boolean;
  leftWithPermission: boolean;
  comment: string;
}

export async function markShiftWorkerLeftEarly(
  params: MarkShiftWorkerLeftEarlyParams
): Promise<WorkerLeftEarlyResponse> {
  const { shiftId, replacementRequested, leftWithPermission, comment } = params;
  const data = {
    data: {
      attributes: {
        shiftId,
        comment,
        leftWithPermission,
        replacementRequested,
      },
      type: API_TYPES.workerLeftEarlyRequest,
      id: shiftId,
    },
  };

  const response = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .post(`${global.api}/worker-left-early-requests`)
    .set(await getAuthHeader())
    .send(data);

  return workerLeftEarlyResponseSchema.parse(response.body);
}
